import React from 'react';
import {Button, Form, FormGroup, Label, FormText, Container, Row, Col, Badge} from 'reactstrap';
import axios from 'axios';
import "react-table/react-table.css";
import Calendar from 'react-calendar';
import _ from 'lodash';
import withTracker from '../containers/Full/withTracker';
import {withRouter, Link} from "react-router-dom";
import {connect} from 'react-redux';

import {showAllList, showLastMsg} from "../modules/actions/message";
import '../styles/chat.scss';
import '../styles/profile.scss';
import 'react-chat-elements/dist/main.css';
import Swal from "sweetalert2";

import travellerIcon from '../img/traveller.jpg';


class MessageList extends React.Component {
    constructor(props) {
        super(props);
        // console.log("this props", this.props.match.params.msgId);
        this.state = {
        };
        this.showAllList = this.showAllList.bind(this);
        this.showLastMsg = this.showLastMsg.bind(this);
    }

    componentDidMount() {
        this.showAllList();
    }

    async showAllList(){
        let result = await this.props.dispatch(showAllList());
        console.log("message list ", result);
        {
            result &&
            this.setState({
                chatUser: _.map(result,
                    // result.senderName === this.props.user.username ? 'recipientName' : 'senderName'
                    (result) => {
                        // result.senderName === this.props.user.username ? 'recipientName' : 'senderName'
                        return result.senderName === this.props.user.username ?
                            result.recipientName : result.senderName
                    }
                ),
                inbox: result
            })
        }
        console.log("this state", this.state);
        this.setState({
            chatNum : this.state.chatUser.length
        })
    }

    async showLastMsg(){
        let payload = {
            // "messageId":
        }
        let result = await this.props.dispatch(showLastMsg());
        console.log("message list ", result);
    }


    render() {
        return (
            <React.Fragment>
                <h1 className="text-center">
                    {this.state.chatNum} chats in inbox
                </h1>
                <Row>
                    <Col xs={2}></Col>
                    <Col xs={8}>
                        {
                            // this.state.chatUser && this.state.chatUser.map((username)=>{
                                this.state.inbox && this.state.inbox.map((inbox)=>{
                                    let username = inbox.senderName === this.props.user.username ?
                                        inbox.recipientName : inbox.senderName
                                    return (
                                        <div>
                                            <div style={{"font-size":"20px", "font-weight":"bold"}}>{username}</div>
                                            <a href={"/dashboard/message/"+inbox._id}
                                            style={{"color":"black"}}>Go to chat</a>
                                            <hr></hr>
                                        </div>

                                    );

                                })

                            // })
                        }
                    </Col>
                    <Col xs={2}></Col>
                </Row>
            </React.Fragment>



        );
    }
}

function mapStateToProps(store) {
    return {
        user: store.auth.user,
    };
}


export default withTracker(withRouter(connect(mapStateToProps)(MessageList)));
